import Vue from "vue";
import VueRouter from "vue-router";
import MainView from "@/views/MainView";
import CalendarView from "@/views/CalendarView";
import LoginView from "@/views/LoginView";

import ApprovalView from "@/views/ApprovalView";
import ApprovalList from "@/components/approval/ApprovalList";
import ApprovalCreate from "@/components/approval/ApprovalCreate";
import ApprovalDetail from "@/components/approval/ApprovalDetail";

import EmployeeView from "@/views/EmployeeView";
import EmployeeWrite from "@/components/employee/EmployeeWrite";
import EmployeeDetail from "@/components/employee/EmployeeDetail";

import ProjectView from "@/views/ProjectView";
import ProjectList from "@/components/project/ProjectList";
import ProjectCreate from "@/components/project/ProjectCreate";

import VacationView from "@/views/VacationView";

import DataRoomView from "@/views/DataRoomView";
import DataList from "@/components/dataRoom/DataList";
import DataCreate from "@/components/dataRoom/DataCreate";
import DataDetail from "@/components/dataRoom/DataDetail";

import NoticeView from "@/views/NoticeView";
import NoticeList from "@/components/notice/NoticeList";
import NoticeCreate from "@/components/notice/NoticeCreate";
import NoticeDetail from "@/components/notice/NoticeDetail";

import SettingPlanView from "@/views/SettingPlanView";
import SettingPlanCreate from "@/components/settings/SettingPlanCreate";
import NotFound from "@/views/NotFound";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    { path: "/", component: MainView },
    { path: "/calendar", component: CalendarView },
    { path: "/login", component: LoginView },
    {
      path: "/approval",
      component: ApprovalView,
      children: [
        { path: "list", name: "approvalList", component: ApprovalList },
        { path: "view/:id", name: "approvalView", component: ApprovalDetail },
        {
          path: "write/:id?",
          name: "approvalWrite",
          component: ApprovalCreate,
        },
      ],
    },
    { path: "/employee", component: EmployeeView },
    { path: "/employeeWrite", component: EmployeeWrite },
    { path: "/employee/:id", component: EmployeeDetail },
    // { path: "/employeeDetail", component: EmployeeDetail },
    { path: "/employeeVacation", component: VacationView },
    {
      path: "/project",
      component: ProjectView,
      children: [
        { path: "list", name: "projectList", component: ProjectList },
        { path: "write/:id?", name: "projectWrite", component: ProjectCreate },
      ],
    },
    {
      path: "/data",
      component: DataRoomView,
      children: [
        { path: "list", name: "dataList", component: DataList },
        { path: "view", name: "dataView", component: DataDetail },
        { path: "write", name: "dataWrite", component: DataCreate },
      ],
    },
    {
      path: "/notice",
      component: NoticeView,
      children: [
        { path: "list", name: "noticeList", component: NoticeList },
        { path: "view", name: "noticeView", component: NoticeDetail },
        { path: "write", name: "noticeWrite", component: NoticeCreate },
      ],
    },
    {
      path: "/setting/plan",
      component: SettingPlanView,
      children: [
        {
          path: "write/:id?",
          component: SettingPlanCreate,
        },
      ],
    },
    { path: "*", component: NotFound },
  ],
});

export default router;
